// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"musician-notes_breadcrumbs__pgvo6"};